'use strict';

module.exports = {
    FILE_DELETION_SINGLE: 'files.deletion.single',
    FILE_DELETION_SUMMARY: 'files.deletion.summary',
    DELETION_STORAGECLIENT_STARTED: 'deletion.storageclient.started',
    DELETION_STORAGECLIENT_DONE: 'deletion.storageclient.done'
};